module.exports = __webpack_public_path__ + "static/russell-hardin.9eaa109d.webp";